import React, { PureComponent as Component } from 'react';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { Toolbars as ToolBarContainer } from '../../../../../components/Card/CardHeaderWithToolbars'

export default class Toolbars extends Component {
  render(){
    return(
      <ToolBarContainer>
        <Button
          title="Run Auto Disburse"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="success"
          onClick={this.props.onDisburse}>
          <i className="fa fa-money"></i>
        </Button>
        <Button
          title="Refresh"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="info"
          onClick={this.props.onRefreshList}>
          <i className="fa fa-refresh"></i>
        </Button>
        <Button
          title="Reset filter"
          className="with-toolbars__toolbars__btn"
          size="sm"
          color="warning"
          onClick={this.props.onResetFilter}>
          <i className="fa fa-ban"></i>
        </Button>
        <Button
          title="Search and Filter Data"
          size="sm"
          className={classNames("with-toolbars__toolbars__btn",{"btn-danger":this.props.isOpen})}
          onClick={this.props.onToggleFilter}>
          <i className={classNames("fa",{"fa-sliders":!this.props.isOpen, "fa-minus":this.props.isOpen})}></i>
        </Button>
        <Button 
          type="button"
					color="success"
          title="Export sales"
          size="sm"
          className={classNames('with-toolbars__toolbars__btn',{'btn-success':this.props.exporting})}
          onClick={this.props.onToggleExport}
        >            
          <i className={classNames('fa', {'fa-download':!this.props.exporting,'fa-spinner fa-spin':this.props.exporting})}></i>
        </Button>
      </ToolBarContainer>
    )
  }
}

Toolbars.propTypes = {
  isOpen: propTypes.bool,
  onToggleFilter: propTypes.func,
  onToggleExport: propTypes.func,
  onResetFilter: propTypes.func,
  onRefreshList: propTypes.func,
  onDisburse: propTypes.func
}
Toolbars.defaultProps = {
  isOpen: false
}